import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { Box, Switch, TableCell, TableRow } from '@mui/material';
import { fonts } from '@theme/fontsCustomer';
import type { ScimTokenModel } from '@repositories/scimTokenRepository/models/ScimTokenModel';
import { useScimTokenToggle } from './useScimTokenToggle';

type Props = {
  token: ScimTokenModel;
  tenantId: string;
};

export const ScimTokenTableRow = ({ token, tenantId }: Props) => {
  const navigate = useNavigate();
  const { handleToggleStatus } = useScimTokenToggle(tenantId, token.id);

  const handleRowClick = () => {
    navigate(token.id);
  };

  return (
    <StyledTableRow onClick={handleRowClick}>
      <StyledTableCell>{token.description}</StyledTableCell>
      <StyledTableCell>
        <StatusCell>
          <Switch
            size="small"
            checked={token.active}
            onClick={e => e.stopPropagation()}
            onChange={(_, checked) => handleToggleStatus(checked)}
          />
        </StatusCell>
      </StyledTableCell>
      <StyledTableCell>{token.expiresAt || '-'}</StyledTableCell>
      <StyledTableCell>{token.createdDate || '-'}</StyledTableCell>
      <StyledTableCell>{token.lastUsedAt || '-'}</StyledTableCell>
    </StyledTableRow>
  );
};

const StyledTableRow = styled(TableRow)`
  cursor: pointer;
  &:hover {
    background-color: ${({ theme: { colors } }) => colors['bg-gray-lighter']};
  }
`;

const StyledTableCell = styled(TableCell)`
  ${fonts.Body2};
  color: ${({ theme: { colors } }) => colors['text-gray-main']};
`;

const StatusCell = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;
